/**
 * Created by Jerker Nord on 2024-01-08.
 */
import {LonerDuckSymbol} from "../view/features/shootshootduck/symbols/LonerDuckSymbol";
import {LonerDuckMX1Symbol} from "../view/features/shootshootduck/symbols/LonerDuckMX1Symbol";
import {LonerDuckMX2Symbol} from "../view/features/shootshootduck/symbols/LonerDuckMX2Symbol";
import {LonerDuckMaxWinSymbol} from "../view/features/shootshootduck/symbols/LonerDuckMaxWinSymbol";
import {LonerDuckClipSymbol} from "../view/features/shootshootduck/symbols/LonerDuckClipSymbol";

export class LonerPoolDucks {

    private _duckSymbols: LonerDuckSymbol[];
    private _mx1Symbols: LonerDuckMX1Symbol[];
    private _mx2Symbols: LonerDuckMX2Symbol[];
    private _maxWinSymbols: LonerDuckMaxWinSymbol[];
    private _clipSymbols: LonerDuckClipSymbol[];

    public init(): void {
        this._duckSymbols = [];
        for (let i: number = 0; i < 12; i++) {
            this._duckSymbols.push(this.createNewDuckSymbol());
        }
        this._mx1Symbols = [];
        for (let i: number = 0; i < 4; i++) {
            this._mx1Symbols.push(this.createNewMX1Symbol());
        }
        this._mx2Symbols = [];
        for (let i: number = 0; i < 4; i++) {
            this._mx2Symbols.push(this.createNewMX2Symbol());
        }
        this._maxWinSymbols = [];
        for (let i: number = 0; i < 2; i++) {
            this._maxWinSymbols.push(this.createNewMaxWinSymbol());
        }
        this._clipSymbols = [];
        for (let i: number = 0; i < 6; i++) {
            this._clipSymbols.push(this.createNewClipSymbol());
        }
    }

    public getSymbol(symbolName: string, textureName: string, duckValue: number): LonerDuckSymbol {
        if (symbolName == "MX1") {
            return this.getMX1Symbol(symbolName, textureName);
        }
        if (symbolName == "MX2") {
            return this.getMX2Symbol(symbolName, textureName);
        }
        if (symbolName == "MAX") {
            return this.getMaxWinSymbol(symbolName, textureName);
        }
        if (symbolName == "CLIP") {
            return this.getClipSymbol(symbolName, textureName);
        }
        return this.getDuckSymbol(symbolName, textureName);
    }

    private createNewDuckSymbol(): LonerDuckSymbol {
        return new LonerDuckSymbol();
    }

    private getDuckSymbol(symbolName: string, textureName: string): LonerDuckSymbol {
        for (let i: number = 0; i < this._duckSymbols.length; i++) {
            if (this._duckSymbols[i].isUsed == false) {
                this._duckSymbols[i].symbolName = symbolName;
                this._duckSymbols[i].setSymbol(textureName);
                this._duckSymbols[i].isUsed = true;
                return this._duckSymbols[i];
            }
        }
        this._duckSymbols.push(this.createNewDuckSymbol());
        return this.getDuckSymbol(symbolName, textureName);
    }

    private createNewClipSymbol(): LonerDuckClipSymbol {
        return new LonerDuckClipSymbol();
    }

    private getClipSymbol(symbolName: string, textureName: string): LonerDuckClipSymbol {
        for (let i: number = 0; i < this._clipSymbols.length; i++) {
            if (this._clipSymbols[i].isUsed == false) {
                this._clipSymbols[i].symbolName = symbolName;
                this._clipSymbols[i].setSymbol(textureName);
                this._clipSymbols[i].startSymbolSpine(textureName);
                this._clipSymbols[i].isUsed = true;
                return this._clipSymbols[i];
            }
        }
        this._clipSymbols.push(this.createNewClipSymbol());
        return this.getClipSymbol(symbolName, textureName);
    }

    private createNewMX1Symbol(): LonerDuckMX1Symbol {
        return new LonerDuckMX1Symbol();
    }

    private getMX1Symbol(symbolName: string, textureName: string): LonerDuckMX1Symbol {
        for (let i: number = 0; i < this._mx1Symbols.length; i++) {
            if (this._mx1Symbols[i].isUsed == false) {
                this._mx1Symbols[i].symbolName = symbolName;
                this._mx1Symbols[i].setSymbol(textureName);
                this._mx1Symbols[i].startSymbolSpine(textureName);
                this._mx1Symbols[i].isUsed = true;
                return this._mx1Symbols[i];
            }
        }
        this._mx1Symbols.push(this.createNewMX1Symbol());
        return this.getMX1Symbol(symbolName, textureName);
    }

    private createNewMX2Symbol(): LonerDuckMX2Symbol {
        return new LonerDuckMX2Symbol();
    }

    private getMX2Symbol(symbolName: string, textureName: string): LonerDuckMX2Symbol {
        for (let i: number = 0; i < this._mx2Symbols.length; i++) {
            if (this._mx2Symbols[i].isUsed == false) {
                this._mx2Symbols[i].symbolName = symbolName;
                this._mx2Symbols[i].setSymbol(textureName);
                this._mx2Symbols[i].startSymbolSpine(textureName);
                this._mx2Symbols[i].isUsed = true;
                return this._mx2Symbols[i];
            }
        }
        this._mx2Symbols.push(this.createNewMX2Symbol());
        return this.getMX2Symbol(symbolName, textureName);
    }

    private createNewMaxWinSymbol(): LonerDuckMaxWinSymbol {
        return new LonerDuckMaxWinSymbol();
    }

    private getMaxWinSymbol(symbolName: string, textureName: string): LonerDuckMaxWinSymbol {
        for (let i: number = 0; i < this._maxWinSymbols.length; i++) {
            if (this._maxWinSymbols[i].isUsed == false) {
                this._maxWinSymbols[i].symbolName = symbolName;
                this._maxWinSymbols[i].setSymbol(textureName);
                this._maxWinSymbols[i].startSymbolSpine(textureName);
                this._maxWinSymbols[i].isUsed = true;
                return this._maxWinSymbols[i];
            }
        }
        this._maxWinSymbols.push(this.createNewMaxWinSymbol());
        return this.getMaxWinSymbol(symbolName, textureName);
    }
}